module.exports = __webpack_public_path__ + "img/shorepower.e26a19c4.png";